import { ThemeEvents } from '@theme/events';

class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  updateSku = (event) => {
    const newVariant = event.detail.data.newVariant;
    if (!newVariant) return;
    this.textContent = newVariant.sku || '';
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
